'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './directory-list.routes';

export class DirectoryListComponent {
  constructor(SettingsService, dialogs, $state, $stateParams, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.SettingsService = SettingsService;

    this.boardAndStuffSettingName = this.$stateParams.name;
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name + "-" + this.boardAndStuffSettingName, "Directory");

    let METHOD = this.public ? "getPublicByName" : "getByName";

    this.SettingsService[METHOD]({name: this.boardAndStuffSettingName}, setting => {
      this.data = setting.data;
      this.types = Object.keys(setting.data);
    });
  }

  showDetails(entry) {
    let caption = entry.head + " (" + entry.sub + ")";
    let body = entry.detail.about;

    this.dialogs.notify(caption, body);
  }
}

export default angular.module('conduuApp.directoryList', [uiRouter])
  .config(routes)
  .component('directoryList', {
    template: require('./directory-list.html'),
    controller: DirectoryListComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/directory/list/directory-list.component.js